// ============================================================
// Invitation auth helper — arahkan guest ke login sebelum builder
// ============================================================

export function invitationCreatePath(templateSlug = null) {
  const base = '/invitations/create';
  if (!templateSlug) {
    return base;
  }

  return `${base}?template=${encodeURIComponent(templateSlug)}`;
}

export function invitationCheckoutPath(templateSlug) {
  return `/invitations/templates/${encodeURIComponent(templateSlug)}/checkout`;
}

export function resolveInvitationCreateTarget(templateSlug = null, options = {}) {
  const { isPremium = false, isOwned = true } = options;

  if (templateSlug && isPremium && !isOwned) {
    return invitationCheckoutPath(templateSlug);
  }

  return invitationCreatePath(templateSlug);
}

export function goToInvitationCreate(templateSlug = null, options = {}) {
  const target = resolveInvitationCreateTarget(templateSlug, options);
  const store = window.Alpine?.store('auth');

  if (!store?.isLoggedIn) {
    window.location.href = `/login?redirect=${encodeURIComponent(target)}`;
    return false;
  }

  window.location.href = target;
  return true;
}

export function requireInvitationAuth(targetUrl = null) {
  const target = targetUrl || window.location.pathname + window.location.search;
  const store = window.Alpine?.store('auth');

  if (!store?.isLoggedIn) {
    window.location.href = `/login?redirect=${encodeURIComponent(target)}`;
    return false;
  }

  return true;
}
